import React, { useState } from "react";
import styled from "styled-components";
import { DropzoneDialog } from "material-ui-dropzone";
import Button from "@material-ui/core/Button";
import { Image as ImageIcon, CloudUpload, CheckCircle } from "@material-ui/icons";

function TabLogo({ values, handleChange, setFieldValue }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onDropHandler = (files) => {
    files.map((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        //store result into your state array.
        setFieldValue("logo", event.target.result);
        setOpen(false);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <Container>
      <SectionTitle>Logo da Empresa</SectionTitle>
      <SectionSubtitle>
        Adicione o logotipo da empresa. Formatos aceitos: JPEG, PNG, BMP (máx. 5MB)
      </SectionSubtitle>

      <ContentWrapper>
        <LogoPreviewCard>
          <LogoPreview>
            {values.logo ? (
              <>
                <ShowLogo src={values.logo} alt="Logo da empresa" />
                <LogoStatus>
                  <CheckCircle style={{ fontSize: '20px', marginRight: '8px' }} />
                  Logo carregado
                </LogoStatus>
              </>
            ) : (
              <EmptyLogoState>
                <ImageIcon style={{ fontSize: '64px', color: '#cbd5e1', marginBottom: '16px' }} />
                <EmptyText>Nenhuma logo carregada</EmptyText>
              </EmptyLogoState>
            )}
          </LogoPreview>
        </LogoPreviewCard>

        <UploadSection>
          <UploadButton onClick={handleOpen}>
            <CloudUpload style={{ marginRight: '10px', fontSize: '22px' }} />
            {values.logo ? 'Alterar Logo' : 'Adicionar Logo'}
          </UploadButton>
          <UploadHelperText>
            Clique para selecionar ou arraste o arquivo
          </UploadHelperText>
        </UploadSection>
      </ContentWrapper>

      <DropzoneDialog
        open={open}
        filesLimit={1}
        onSave={onDropHandler}
        acceptedFiles={["image/jpeg", "image/png", "image/bmp"]}
        showPreviews={true}
        maxFileSize={5000000}
        onClose={handleClose}
        dialogTitle="Adicionar Logo"
        dropzoneText="Arraste uma imagem aqui ou clique para selecionar"
        cancelButtonText="Cancelar"
        submitButtonText="Salvar"
      />
    </Container>
  );
}

export default TabLogo;

const Container = styled.div`
  width: 100%;
  font-family: 'Mulish', sans-serif;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-family: 'Mulish', sans-serif;
`;

const SectionSubtitle = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0 0 24px 0;
  font-family: 'Mulish', sans-serif;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LogoPreviewCard = styled.div`
  background: #f8f9fa;
  border: 2px dashed #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #8e44ad;
    background: rgba(142, 68, 173, 0.02);
  }
`;

const LogoPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const ShowLogo = styled.img`
  max-height: 200px;
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const LogoStatus = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 8px 16px;
  background: linear-gradient(135deg, rgba(39, 174, 96, 0.1) 0%, rgba(34, 153, 84, 0.1) 100%);
  color: #27ae60;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Mulish', sans-serif;
`;

const EmptyLogoState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const EmptyText = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

const UploadButton = styled(Button)`
  && {
    background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 14px 28px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;
    text-transform: none;
    box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);

    &:hover {
      background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(142, 68, 173, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }
`;

const UploadHelperText = styled.p`
  font-size: 13px;
  color: #7f8c8d;
  margin: 0;
  text-align: center;
  font-family: 'Mulish', sans-serif;
`;
